"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var ContactPreferenceCopy = function ContactPreferenceCopy(_ref) {
  var email = _ref.email;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "You are currently scheduled to receive the following \"checked\" correspondence.  To change your preferences, simply \"check\" or \"uncheck\" the related box.  Click \"Save\" to save your changes.\xA0\xA0", /*#__PURE__*/_react["default"].createElement("em", null, "While changes are usually immediate, please allow five (5) business days to ensure they have taken effect.")), /*#__PURE__*/_react["default"].createElement("p", null, "By the way, your emails are currently being sent to \xA0", /*#__PURE__*/_react["default"].createElement("strong", null, email), "."));
};
ContactPreferenceCopy.propTypes = {
  email: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = (0, _compose["default"])(_pure["default"])(ContactPreferenceCopy);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/contactPreferenceCopy.js
// module id = 2101
// module chunks = 9